/* tslint:disable */
/* eslint-disable */
/**
 * Evidencna aplikacia API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const NahlasenieChybyEnum = {
    Ezbierka: 'EZBIERKA',
    Elegislativa: 'ELEGISLATIVA',
    VykonavaciePredpisy: 'VYKONAVACIE_PREDPISY',
    Tezaury: 'TEZAURY',
    PravoEu: 'PRAVO_EU',
    Judikaty: 'JUDIKATY',
    Registracia: 'REGISTRACIA',
    Ine: 'INE'
} as const;

export type NahlasenieChybyEnum = typeof NahlasenieChybyEnum[keyof typeof NahlasenieChybyEnum];


/**
 * 
 * @export
 * @interface NotificationNahlasenieChyby
 */
export interface NotificationNahlasenieChyby {
    /**
     * 
     * @type {NahlasenieChybyEnum}
     * @memberof NotificationNahlasenieChyby
     */
    'oblast': NahlasenieChybyEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationNahlasenieChyby
     */
    'popisChyby': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNahlasenieChyby
     */
    'email': string;
}



/**
 * AktualityRssApi - axios parameter creator
 * @export
 */
export const AktualityRssApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get rss of aktuality.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAktualityRss: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/aktuality/rss`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AktualityRssApi - functional programming interface
 * @export
 */
export const AktualityRssApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AktualityRssApiAxiosParamCreator(configuration)
    return {
        /**
         * Get rss of aktuality.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAktualityRss(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAktualityRss(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AktualityRssApi.getAktualityRss']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AktualityRssApi - factory interface
 * @export
 */
export const AktualityRssApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AktualityRssApiFp(configuration)
    return {
        /**
         * Get rss of aktuality.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAktualityRss(options?: any): AxiosPromise<string> {
            return localVarFp.getAktualityRss(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AktualityRssApi - object-oriented interface
 * @export
 * @class AktualityRssApi
 * @extends {BaseAPI}
 */
export class AktualityRssApi extends BaseAPI {
    /**
     * Get rss of aktuality.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AktualityRssApi
     */
    public getAktualityRss(options?: RawAxiosRequestConfig) {
        return AktualityRssApiFp(this.configuration).getAktualityRss(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationNahlasenieChybyApi - axios parameter creator
 * @export
 */
export const NotificationNahlasenieChybyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send reporting error notification.
         * @param {NotificationNahlasenieChyby} notificationNahlasenieChyby 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotificationNahlasenieChyby: async (notificationNahlasenieChyby: NotificationNahlasenieChyby, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationNahlasenieChyby' is not null or undefined
            assertParamExists('sendNotificationNahlasenieChyby', 'notificationNahlasenieChyby', notificationNahlasenieChyby)
            const localVarPath = `/notifications/nahlasenie-chyby`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationNahlasenieChyby, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationNahlasenieChybyApi - functional programming interface
 * @export
 */
export const NotificationNahlasenieChybyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationNahlasenieChybyApiAxiosParamCreator(configuration)
    return {
        /**
         * Send reporting error notification.
         * @param {NotificationNahlasenieChyby} notificationNahlasenieChyby 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNotificationNahlasenieChyby(notificationNahlasenieChyby: NotificationNahlasenieChyby, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNotificationNahlasenieChyby(notificationNahlasenieChyby, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationNahlasenieChybyApi.sendNotificationNahlasenieChyby']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationNahlasenieChybyApi - factory interface
 * @export
 */
export const NotificationNahlasenieChybyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationNahlasenieChybyApiFp(configuration)
    return {
        /**
         * Send reporting error notification.
         * @param {NotificationNahlasenieChyby} notificationNahlasenieChyby 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotificationNahlasenieChyby(notificationNahlasenieChyby: NotificationNahlasenieChyby, options?: any): AxiosPromise<void> {
            return localVarFp.sendNotificationNahlasenieChyby(notificationNahlasenieChyby, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationNahlasenieChybyApi - object-oriented interface
 * @export
 * @class NotificationNahlasenieChybyApi
 * @extends {BaseAPI}
 */
export class NotificationNahlasenieChybyApi extends BaseAPI {
    /**
     * Send reporting error notification.
     * @param {NotificationNahlasenieChyby} notificationNahlasenieChyby 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationNahlasenieChybyApi
     */
    public sendNotificationNahlasenieChyby(notificationNahlasenieChyby: NotificationNahlasenieChyby, options?: RawAxiosRequestConfig) {
        return NotificationNahlasenieChybyApiFp(this.configuration).sendNotificationNahlasenieChyby(notificationNahlasenieChyby, options).then((request) => request(this.axios, this.basePath));
    }
}



